import React from "react";
import PropTypes from "prop-types";

const VersionText = (props) => {
  const { anchorUrl, anchorText, versionText } = props;
  return (
    <small>
      <i>
        {anchorUrl && (
          <React.Fragment>
            <a href={anchorUrl} target="_blank">
              {anchorText}
            </a>
          </React.Fragment>
        )}
        {" version "}
        {versionText}
      </i>
    </small>
  );
};

VersionText.propTypes = {
  anchorUrl: PropTypes.string,
  anchorText: PropTypes.string,
  versionText: PropTypes.string,
};

VersionText.defaultProps = {
  anchorUrl: null,
  anchorText: null,
  versionText: null,
};

export default VersionText;
